/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pure_Jade_Dog_DartInputs */

const en_pure_jade_dog_dart = /** @type {(inputs: Pure_Jade_Dog_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic classification queued`)
};

const de_pure_jade_dog_dart = /** @type {(inputs: Pure_Jade_Dog_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themenklassifizierung in der Warteschlange`)
};

/**
* | output |
* | --- |
* | "Topic classification queued" |
*
* @param {Pure_Jade_Dog_DartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pure_jade_dog_dart = /** @type {((inputs?: Pure_Jade_Dog_DartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pure_Jade_Dog_DartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pure_jade_dog_dart(inputs)
	return de_pure_jade_dog_dart(inputs)
});